import { TableSimpleCellProps, TableSimpleDataItem } from "ds/components/TableSimple/types";

import EnvironmentTableCell from "../Cell";

const EmptyActionsCell = <T extends TableSimpleDataItem>(props: TableSimpleCellProps<T>) => {
  return <EnvironmentTableCell {...props} />;
};

export default EmptyActionsCell;
